import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <br>
      </br>
      <br>
      </br>
      <br>
      </br>
      <br>
      </br>
      <h2>Capstone ELEC/COEN 490 TEAM 20</h2>
      <p>Upload your Experience</p>
    </div>
  )
}

export default Title;